module.exports = __webpack_public_path__ + "img/gotask.87a2ee6d.svg";